module.exports = __webpack_public_path__ + "img/1_11@2x.edcdfc38.png";